/* eslint-disable react/prop-types */
import React, { useState, useRef, useCallback, useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import SelectedProduct from '../../entities/SelectedProduct';
import { buy, resetErrorOnBuy } from '../../actions';

import { addBuild } from '../../actions';

const ProjectPurchase = ({ builds, buying, dispatch, state, setEnableBuilder }) => {
    const [selectedBuilds, setSelectedBuilds] = useState([]);
    const modal = useRef(null);

    const handleProjectCheckToggle = useCallback(
        (selectedBuild) => {
            const existingIndex = selectedBuilds.findIndex(
                (build) => build.projectTitle === selectedBuild.projectTitle
            );
            const currentSelectedBuilds = [...selectedBuilds];
            if (existingIndex === -1) {
                currentSelectedBuilds.push(selectedBuild);
            } else {
                currentSelectedBuilds.splice(existingIndex, 1);
            }
            setSelectedBuilds([...currentSelectedBuilds]);
        },
        [selectedBuilds]
    );

    const handleAddAllAvailableToCartClick = () => {
        const completedBuilds = builds.filter((build) => {
            const notReady = !build.projectTitle;

            // if (!notReady) {
            //     handleProjectCheckToggle(build);
            // }

            return !notReady;
        });
        // const completedBuilds = builds.filter((build) => {
        //     const errors = [];
        //     const projectTitle = build.projectTitle ? build.projectTitle : 'This project';

        //     if(!build.projectTitle) {
        //         errors.push('Project needs a title before you can add to cart');
        //     }

        //     if (!build.selected.heads) {
        //         errors.push(`${projectTitle} is missing a head piece`);
        //     }

        //     if (!build.selected.bodies) {
        //         errors.push(`${projectTitle} is missing a body piece`);
        //     }

        //     if (!build.selected.legs) {
        //         errors.push(`${projectTitle} is missing a legs piece`);
        //     }

        //     if (errors.length > 0) {
        //         dispatch({
        //             type: ERROR_BUYING,
        //             payload: {
        //                 errorMessage: errors,
        //             },
        //         });
        //         return false;
        //     } else {
        //         return true
        //     }
        // });
        if (completedBuilds.length > 0) {
            handleAddToCart(completedBuilds);
        }
    };

    const handleAddToCart = (projects) => {
        dispatch(buy(projects));
    };

    const handleAddBuild = () => {
        const builder = document.querySelector('.minifig-builder');
        builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        dispatch(addBuild());
    };

    useEffect(() => {
        if (state.errorMessage || state.errorOnBuy) {
            modal.current.showModal();
        }
    }, [state.errorMessage, state.errorOnBuy]);

    const prices = useMemo(() => {
        return builds.map((build) => SelectedProduct.calculateCost(build.selected)?.toFixed(2));
    }, [builds]);

    const hasMissingParts = useMemo(() => {
        return builds.some((build) => {
            const missingHead = !build.selected.heads;
            const missingBody = !build.selected.bodies;
            const missingLeg = !build.selected.legs;
            const missingHatsandHair = !build.selected.hatsAndHair;

            return !build.projectTitle || missingHead || missingBody || missingLeg || missingHatsandHair;
        });
    }, [builds]);

    return (
        <div className="purchase-container">
            <div className="project__list__add_new_project">
                <button className="button btn span" onClick={handleAddBuild}>
                    <span>Add new project</span>
                </button>
            </div>
            <div className="project__list__add_to_basket">
                <button
                    className="button btn span"
                    onClick={() => {
                        modal.current.showModal();
                        dispatch(resetErrorOnBuy());
                    }}
                >
                    <span>{`Add project${builds.length > 1 ? 's' : ''} to cart`}</span>
                </button>
            </div>
            <dialog ref={modal} className="project_switcher-add-to-basket-modal">
                <h2>Add to cart</h2>
                <div className="project_switcher__fakeTableHeader">
                    <span>Project name</span>
                    <span>Price</span>
                </div>
                <table className="project_switcher-add-to-basket-table">
                    <tbody>
                        {builds.map((build, buildIndex) => {
                            const missingHead = !build.selected.heads;
                            const missingBody = !build.selected.bodies;
                            const missingLeg = !build.selected.legs;
                            const missingHatsandHair = !build.selected.hatsAndHair;

                            const notReady = !build.projectTitle;
                            const missingParts =
                                !build.projectTitle || missingHead || missingBody || missingLeg || missingHatsandHair;

                            return (
                                <tr
                                    key={`project-add-to-cart-${build.projectTitle}-${prices[buildIndex]}`}
                                    className={` ${notReady ? 'disabled' : ''}`}
                                >
                                    <td>
                                        <input
                                            type="checkbox"
                                            disabled={notReady}
                                            onChange={() => handleProjectCheckToggle(build)}
                                        />
                                    </td>
                                    <td className="project_switcher__titleAndWarnings">
                                        <div className="project_switcher-add-to-basket-item-label">
                                            {build.projectTitle ? build.projectTitle.split('-')[0] : '[Untitled]'}
                                        </div>
                                        <div className="project_switcher__warnings">
                                            <div className="project_switcher__warnings--icon">
                                                <i
                                                    className={`project_switcher-add-to-basket-item-ready-icon ${
                                                        !missingParts
                                                            ? 'project_switcher-add-to-basket-item-ready'
                                                            : 'project_switcher-add-to-basket-item-not-ready'
                                                    }`}
                                                />
                                            </div>
                                            <div className="project_switcher__warnings--textContainer">
                                                {!build.projectTitle && (
                                                    <div className="project_switcher__warnings--text">
                                                        Project needs a title before you can add to cart
                                                    </div>
                                                )}
                                                {missingHead && (
                                                    <div className="project_switcher__warnings--text">
                                                        This project is missing a head piece
                                                    </div>
                                                )}
                                                {missingBody && (
                                                    <div className="project_switcher__warnings--text">
                                                        This project is missing a body piece
                                                    </div>
                                                )}
                                                {missingLeg && (
                                                    <div className="project_switcher__warnings--text">
                                                        This project is missing a legs piece
                                                    </div>
                                                )}
                                                {missingHatsandHair && (
                                                    <div className="project_switcher__warnings--text">
                                                        Your project is missing a hat or hair
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="project_switcher__price">£{prices[buildIndex]}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {hasMissingParts && (
                    <div className="project_switcher-add-to-basket-warning">
                        <i
                            className={`project_switcher-add-to-basket-item-ready-icon project_switcher-add-to-basket-item-not-ready`}
                        />
                        <span>You have some incomplete projects in your cart</span>
                    </div>
                )}
                {state.errorMessage && (
                    <div className="project_switcher-add-to-basket-warning">
                        {state.errorMessage?.map((error) => (
                            <span key={error}>{error}</span>
                        ))}
                        {state.addedProjects?.length > 0 && state.addedProjects && (
                            <div>
                                <span>The following projects were added to your cart:</span>
                                <ul>
                                    {state.addedProjects?.map((project) => (
                                        <li key={project}>{project}</li>
                                    ))}
                                </ul>
                                <a href="/cart">Go to cart</a>
                            </div>
                        )}
                    </div>
                )}

                <div className="project_switcher-add-to-basket-actions">
                    <button
                        className="project_switcher-add-to-basket-actions__close"
                        onClick={() => {
                            setEnableBuilder(true);

                            modal.current.close();
                        }}
                    >
                        <span>Back</span>
                    </button>
                    <div className="project_switcher-add-to-basket-actions__buy">
                        {builds.length > 1 && (
                            <button
                                className="button btn span"
                                onClick={() => handleAddToCart(selectedBuilds)}
                                disabled={buying || selectedBuilds.length === 0}
                            >
                                <span>Add selected</span>
                            </button>
                        )}
                        <button
                            className="button btn span"
                            onClick={handleAddAllAvailableToCartClick}
                            disabled={
                                builds?.filter((build) => {
                                    const ready = build.projectTitle;
                                    return ready;
                                })?.length !== builds?.length
                            }
                        >
                            <span>{builds.length > 1 ? 'Add all' : 'Add to cart'}</span>
                        </button>
                    </div>
                </div>
            </dialog>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        currentBuildIndex: state.currentBuildIndex,
        builds: state.builds,
        buying: state.buying,
        state,
    };
};

export default connect(mapStateToProps)(ProjectPurchase);
